import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Select from "react-select";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import paginationFactory from "react-bootstrap-table2-paginator";
import preloader from "../../../helpers/preloader";
import calculatePrice from "../../../helpers/calculate_price";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../helpers/units";
import EnterQuantityForPoModal from "../../../components/EnterQuantityForPoModal";
import UpdateQuantityForPoModal from "../../../components/UpdateQuantityForPoModal";
import AllDrafts from "./AllDrafts";

const CreateDraftPO = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartModal, setCartModal] = useState(false);
  const [searchkey, setSearchKey] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);


  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const pagination_options = {
    onPageChange: (page, sizePerPage) => {
      setPageNumber(page);
      setPageSize(sizePerPage);
    },
    paginationSize: 100,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "300",
        value: 300,
      },
      {
        text: "All",
        value: filteredItems && filteredItems.length,
      },
    ],
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  useEffect(() => {
    loadAllStores();
    // loadItems();
    loadDraftOrders();
  }, []);

  const [selectedItems, setSelectedItems] = useState([]);
  const [allBranches, setAllStores] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [deliverAtBranch, setDeliverAtBranch] = useState(false);
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [editUnitModal, setEditUnitModal] = useState(false);

  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result = [
        { label: "CENTRAL STORE", value: "", _id: "" },
        ...response.data.filter((branch) => branch.type !== "CENTRAL STORE"),
      ];
      setAllStores(result);
    } else {
      showNotification(response.message, "Error");
    }
  };
  

  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const [openDraftModal, setOpenDraftModal] = useState(false);
  const [draftOrders, setDraftOrders] = useState([]);
  const loadDraftOrders = async () => {
    let url = process.env.REACT_APP_BASEURL + "po_draft/get_draft";
    let response = await postSubmitForm(url, {type:"Branch_Wise"});
    if (response.status === 1) {
      setDraftOrders(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [suppliers, setSuppliers] = useState([])
  const loadSuupliers = async (category) => {
    let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
    let response = await postSubmitForm(url, { categories: [category.category] });
    if (response.status === 1) {
      const supplier = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      // const UpdatedWithSupplier = categorisezItem.map((item) =>
      //   item.category === e.category ? { ...item, suppliers: supplier } : item
      // );
       const updatedSuppliers = supplier.map((s) => ({
         value: s.value || s.name,
         name: s.name,
       }));
        setCategorisezItem((prevCategorisezItem) =>
          prevCategorisezItem.map((itm) =>
            itm.category === category.category
              ? {
                  ...itm,
                  suppliers: updatedSuppliers,
                  selSupp: itm.selSupp || category.selSupp,
                }
              : itm
          )
        );
      // setCategorisezItem(UpdatedWithSupplier);
      setSuppliers(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const loadItems = async (branchId = null) => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "items/get_branchwise_for_po";
     const response = await postSubmitForm(url, {
       branch_id:
         branchId === null ? selectedBranch && selectedBranch.value : branchId,
     });
    if (response && response.status === 1) {
      const updatedItems = response.data.filter((d)=>d.is_active).map((item) => ({
        ...item,
        total_price: 0,
      }));
      const SortedData = updatedItems.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      preloader(false);
      setAllItems(SortedData);
      setFilteredItems(SortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };


  useEffect(() => {
    filterItems(allItems);
  }, [searchkey]);

  const filterItems = async (allItems) => {    
    if (!searchkey || searchkey.trim() === "") {
      return setFilteredItems(allItems);
    }
    
    const filteredItems = allItems?.filter((item) => {
      return (
        item.name.toLowerCase().includes(searchkey.toLowerCase()) ||
        item.category.toLowerCase().includes(searchkey.toLowerCase())
      );
    });

    setFilteredItems(filteredItems);
  };

  

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        const rowNumber = (+pageNumber - 1) * +pageSize + (+rowIndex + 1);
        return rowNumber;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "45%" };
      },
      editable: false,
    },
    {
      text: props.t("Cat."),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Sub-Cat."),
      dataField: "sub_category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      text: props.t("Brand"),
      dataField: "brand",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
  ];

  const handleDeleteRow = (itemId) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter(
        (item) => item.item_id !== itemId
      );
      return updatedCartItems;
    });
  };


  const columns_cartitems = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      footer: false,
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <span className="me-2">
                {formatUnitsForReport(row.quantity)}
              </span>
                <Button
                  className="btn btn-success btn-sm"
                  onClick={() => {
                    setSelectedItems(row);
                    setSelectedRowsUnit(row.quantity);
                    setEditUnitModal(true);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
            </div>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Price"),
      dataField: "price",
      formatter: (cell, row) => {
        return row.price + " / " + row.unit_for_po;
      },
      sort: false,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: false,
    },
    {
      text: props.t("Total"),
      dataField: "total_price",
      sort: false,
      formatter: (cell, row) => {
        return row.total_price ? Number(row.total_price).toFixed(2) :""
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      editable: false,
      footer: (columnData) => {
        const total = columnData?.reduce((acc, item) => acc + item, 0);
        return total ? Number(total).toFixed(2) : "";
      },
    },
    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.item_id);
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const populateCartFromDraft = async (draftPO) => {
    setIsLoadingDraft(true);

    const branchDetails = {
      label: draftPO.branch_details.name,
      value: draftPO.branch_details._id,
      ...draftPO.branch_details,
    };
    const newCartCategorizesItems = draftPO.items.map((category) => ({
      category: category.category,
      selSupp: category.supplier, 
      items: category.items.map((item) => ({
        ...item,
        category: category.category,
      })),
      suppliers: [], 
    }));
    setSelectedBranch(branchDetails);
     const isCentralStore = branchDetails.label === "CENTRAL STORE";
     await loadItems(isCentralStore ? "" : branchDetails.value);
setCartItems(newCartCategorizesItems.flatMap((category) => category.items));
setCategorisezItem(newCartCategorizesItems);   
 setDeliverAtBranch(draftPO.deliver_at_branch);
    for (const category of newCartCategorizesItems) {
      await loadSuupliers(category);
    }
    setIsLoadingDraft(false);
  };

  const [selectedDraftID, setSelectedDraftID] = useState("");
  const handleDraftPOSelection = (row) => {
    // return
    setSelectedDraftID(row._id);
    populateCartFromDraft(row);
    setOpenDraftModal(false);
  };

  const handleBranchSelection = (selectedOption) => {
    setSelectedBranch(selectedOption);
    setDeliverAtBranch(false)
    setCartItems([]);
    setCategorisezItem([]);
    loadItems(
      selectedOption.label === "CENTRAL STORE" ? "" : selectedOption.value
    );
  };
  const selectDraftPORow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        handleDraftPOSelection(row);
      }
    },
    selected: [selectedDraftID],
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: true,
    bgColor: "#ecf0a1",
    selected: cartItems.map((item) => item.item_id),
    nonSelectable: cartItems
      .filter((cartItem) =>
        filteredItems.some(
          (filterItem) => filterItem.item_id === cartItem.item_id
        )
      )
      .map((item) => item.item_id),
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        setSelectedItems(row);
        SelectDefaultUnit(row);
        updateSelectedItems(row, isSelect);
      } else {
        e.preventDefault();
      }
    },
  };
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  function SelectDefaultUnit(row) {
    setSelectedRowsUnit([
      {
        index: 0,
        unit: row.unit_levels[0].unit,
        formula: row.unit_levels[0].value,
        value: 0,
        isChecked: true,
      },
    ]);
    setSelectUnitModal(true);
  }

  function updateSelectedItems(row, isSelect) {
    setCartItems((prevSelected) => {
      if (isSelect) {
        if (!prevSelected.some((item) => item.item_id === row.item_id)) {
          return [...prevSelected, row];
        }
      } else {
        const isnoUnitsSelected = selectedRowsUnit.every(
          (unit) => !unit.isChecked
        );
        if (isnoUnitsSelected) {
          return prevSelected.filter((item) => item.item_id !== row.item_id);
        }
      }
      return prevSelected;
    });
  }

const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmitDraft = async () => {
 let payload = categorisezItem.map((category) => ({
   category: category.category,
   supplier: category.selSupp,
   items: category.items.map((item) => ({
     item_id: item.item_id,
     name: item.name,
     category: item.category,
     sub_category: item.sub_category,
     brand: item.brand,
     unit_levels: item.unit_levels,
     unit_for_po: item.unit_for_po,
     quantity:item.quantity,
     price: +item.price,
     total_price: +item.total_price,
   })),
 }));    // console.log(payload);
    //  return

    try {
    if (
        categorisezItem.some((category) =>
          category.items.some((item) =>
            item.quantity.length > 0 && item.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))
          )
        )
      ) {
        showNotification("Please enter a valid quantity for at least one unit", "Warning");
        return;
      }
      if (categorisezItem.length > 0) {
        setIsSubmitting(true);
        let url = process.env.REACT_APP_BASEURL + "po_draft/save_draft";
        let data_to_send = { items: payload };
        data_to_send.draft_id = selectedDraftID;
        data_to_send.type = "Branch_Wise";
        if (selectedBranch !== "") {
          data_to_send.branch_id = selectedBranch && selectedBranch._id;
        }
        data_to_send.deliver_at_branch = deliverAtBranch;
        // console.log(data_to_send);
        let response = await postSubmitForm(url, data_to_send);
        if (response.status === 1) {
          setSelectedDraftID("");
          loadDraftOrders();
          loadItems("")
          showNotification(response.message, "Success");
          setCartItems([]);
          setCategorisezItem([]);
          setDeliverAtBranch(false)
          setCartModal(!cartModal);
          setSelectedItems([]);
          setSelectedBranch("");
          setSelectedRowsUnit([]);      
        } else {
          showNotification(response.message, "Error");
        }
      } else {
        showNotification(
          "Please select at least one item and supplier.",
          "Error"
        );
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
        setIsSubmitting(false);
    }
  };

  const handleAddUnits = (qty) => {
    const updatedCartItems = cartItems.map((item) => {
      let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
      if (item.item_id === selectedItems.item_id) {
        const total_price = calculatePrice(
          selectedItems.unit_levels,
          convertedQuantity,
          item.price,
          item.unit_for_po
        );
        return { ...item, quantity: convertedQuantity, total_price };
      } else {
        return item;
      }
    });

    setCartItems(updatedCartItems);
    setSelectUnitModal(false);
    setSelectedItems([]);
    setSelectedRowsUnit([]);
  };

  const [categorisezItem, setCategorisezItem] = useState([]); 
  function groupBy(array, property) {
    return Object.values(
      array.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = {category: key,items: [],
            suppliers: obj.suppliers || [],
            selSupp: obj.selSupp || "",
          };
        }
        acc[key].items.push(obj);
        return acc;
      }, {})
    );
  }

  useEffect(() => {
    setCategorisezItem((prevCategorizedItems) => {
      const newCategorizedItems = groupBy(cartItems, "category");

      return Object.values(newCategorizedItems).map((category) => {
        const existingCategory = prevCategorizedItems.find(
          (c) => c.category === category.category
        );
        return {
          ...category,
          suppliers: existingCategory ? existingCategory.suppliers : [],
          selSupp: existingCategory ? existingCategory.selSupp : "",
        };
      });
    });
  }, [cartItems]);

  function handleCloseModal() {
    const hasValidquantity =
      selectedItems?.quantity &&
      selectedItems.quantity.every((unit) => unit.value > 0);
    if (!hasValidquantity) {
      setCartItems((prevCartItems) =>
        prevCartItems.filter((item) => item.item_id !== selectedItems.item_id)
      );
    }
    setSelectUnitModal(false);
  }

  const handleUpdateUnit = (qty) => {
    let convertedQuantity =  GetUpdatedDelivered(qty, selectedItems?.unit_levels) 
    const isItemInCart = cartItems.some(
      (item) => item.item_id === selectedItems.item_id
    );
    if (isItemInCart) {
      const updatedCartItems = cartItems.map((item) =>
        item.item_id === selectedItems.item_id
          ? {
              ...item,
              quantity: convertedQuantity,
              total_price: calculatePrice(
                item.unit_levels,
                convertedQuantity,
                item.price,
                item.unit_for_po
              ),
            }
          : item
      );
      setCartItems(updatedCartItems);
      setEditUnitModal(false);
    } else {
      const newItem = {
        ...selectedItems,
        quantity: convertedQuantity,
        total_price: calculatePrice(
          selectedItems.unit_levels,
          convertedQuantity,
          selectedItems.price,
          selectedItems.unit_for_po
        ),
      };
      setCartItems((prevCartItems) => [...prevCartItems, newItem]);
      setEditUnitModal(false);
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Store-wise Draft Purchase Order")}
            title={props.t("Procurement")}
            breadcrumbItem1={props.t("Store-wise Draft Purchase Order")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody style={{ height: "120px" }}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <AvField
                          name="search"
                          label={props.t("Search")}
                          placeholder={props.t("Search items here")}
                          type="text"
                          onChange={(e) => {
                            e.preventDefault();
                            setSearchKey(e.target.value);
                          }}
                        ></AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
            <Col lg={6}>
              <Card>
                <CardBody style={{ height: "120px" }}>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <Label>{props.t(" Store/Branch")}</Label>
                        <Select
                          options={allBranches}
                          placeholder={props.t("None")}
                          onChange={handleBranchSelection}
                          value={selectedBranch}
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      </Col>

                      {selectedBranch && selectedBranch.label !== "None" && (
                        <Col lg={12} className="mt-2" hidden={selectedBranch.label === "CENTRAL STORE"}>
                          <AvField
                            type="checkbox"
                            name="avFieldCheckbox"
                            onChange={(e) => {
                              setDeliverAtBranch(!deliverAtBranch);
                            }}
                            checked={deliverAtBranch}
                            label="Deliver at store/branch."
                          />
                        </Col>
                      )}
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={2} lg={2} className="text-start">
                      <div>
                        <Button
                          type="submit"
                          color="success"
                          className="mb-2"
                          onClick={() => setOpenDraftModal(true)}
                        >
                          {props.t("View Drafts")}
                        </Button>
                      </div>
                    </Col>
                    <Col md={8} lg={8}></Col>
                    <Col
                      md={2}
                      lg={2}
                      className="d-flex justify-content-end text-align-end"
                    >
                      <div>
                        <Button
                          type="submit"
                          color="primary"
                          className="mb-2"
                          onClick={() =>
                            setCartModal(!cartModal)
                          }
                        >
                          {props.t("View Cart")}
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <ToolkitProvider
                    bootstrap4
                    keyField="item_id"
                    data={filteredItems}
                    columns={columns_items}
                    noDataIndication={props.t("No data to display.")}
                    search
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          pagination={paginationFactory(pagination_options)}
                          striped
                          hover
                          condensed
                          selectRow={selectRow}
                          {...props.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Cart Modal start  */}
          <Modal
            size="lg"
            isOpen={cartModal}
            toggle={() => setCartModal(!cartModal)}
          >
            <ModalHeader
              toggle={() => setCartModal(!cartModal)}
            >
              {props.t("Review Order Details")}
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={12}>
                          {categorisezItem &&
                            categorisezItem.map((item) => {
                              if (item.items.length > 0) {
                                return (
                                  <>
                                    <Row>
                                      <Col lg={8}>
                                        <Label>
                                          {props.t("Category")}: {item.category}
                                        </Label>
                                      </Col>
                                      {/* <Col lg={4}>
                                        <AvForm>
                                          <AvField
                                            name="supplier"
                                            type="select"
                                            value={
                                              item.selSupp
                                                ? typeof item.selSupp ===
                                                  "object"
                                                  ? item.selSupp.id ||
                                                    item.selSupp.name
                                                  : item.selSupp
                                                : ""
                                            }
                                            onClick={() => loadSuupliers(item)}
                                            onChange={(e) =>
                                              handleSupplierSelection(e, item)
                                            }
                                          >
                                            <option value="">
                                              {props.t("--Select Supplier--")}
                                            </option>
                                            {item.suppliers &&
                                              item.suppliers.map((e) => (
                                                <option
                                                  key={e.value || e.name}
                                                  value={e.value || e.name}
                                                >
                                                  {e.name}
                                                </option>
                                              ))}
                                          </AvField>
                                        </AvForm>

                                       
                                      </Col> */}
                                    </Row>
                                    <ToolkitProvider
                                      bootstrap4
                                      keyField="item_id"
                                      data={item.items}
                                      columns={columns_cartitems}
                                      noDataIndication={props.t(
                                        "No data to display."
                                      )}
                                      search
                                    >
                                      {(props) => (
                                        <div>
                                          <BootstrapTable
                                            striped
                                            hover
                                            condensed
                                            cellEdit={cellEditFactory({
                                              mode: "click",
                                              blurToSave: true,
                                              afterSaveCell: (
                                                oldValue,
                                                newValue,
                                                row,
                                                column
                                              ) => {
                                                // console.log(row.price, row.quantity);
                                              },
                                            })}
                                            {...props.baseProps}
                                          />
                                        </div>
                                      )}
                                    </ToolkitProvider>
                                  </>
                                );
                              }
                            })}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={12}>
                      <FormGroup className="mb-0 text-center">
                        <div>
                          
                          <Button
                            type="submit"
                            color="primary"
                            style={{width:"150px"}}
                            disabled={categorisezItem?.length <= 0 || isSubmitting}
                            onClick={() => handleSubmitDraft()}
                          >
                            {isSubmitting ? <Spinner  size={"sm"}/> : props.t("Save as Draft")}
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </Modal>
          {/* Cart Modal End  */}

          {/* Draft Modal start  */}
          <AllDrafts
                      isOpen={openDraftModal}
                      toggle={() => setOpenDraftModal(!openDraftModal)}
                      title={props.t("All Draft Purchase Orders")}
                      data={draftOrders}
                      keyField="_id"
                      selectRow={selectDraftPORow}
                      noDataMessage={props.t("No data to display.")}
                      onDelete={()=>loadDraftOrders()}
                      showSupplierColumn={false}
                      storeType="Branch"
                    />
          {/* Draft Modal end  */}

          {/* Add Quantity modal  start */}
          <EnterQuantityForPoModal 
          isOpen={selectUnitModal}
          toggle={handleCloseModal}
          onSubmit={handleAddUnits}
          item={selectedItems}
          selectedUnits={selectedRowsUnit}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />
          {/* Add Quantity modal end */}

          {/* Edit Quantity Modal start  */}
           <UpdateQuantityForPoModal 
          isOpen={editUnitModal}
          toggle={()=>setEditUnitModal(false)}
          onSubmit={handleUpdateUnit}
          item={selectedItems}
          cartItems={cartItems}
          setCartItems={setCartItems}
          selectedItems={selectedItems}
          />
          {/* Edit Quantity Modal end  */}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(CreateDraftPO))
);
